import { render, staticRenderFns } from "./FileUploadCard.vue?vue&type=template&id=96f5d05e"
import script from "./FileUploadCard.vue?vue&type=script&lang=js"
export * from "./FileUploadCard.vue?vue&type=script&lang=js"
import style0 from "./FileUploadCard.vue?vue&type=style&index=0&id=96f5d05e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports